import { useQuery } from "@tanstack/react-query";
import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../../useAppInsight";
import mapApiDocumentFilterDimensions from "./mapApiDocumentFilterDimensions";

const useGetDocumentDeliveryFilterDimensions = (cardCodes: string[]) => {
  const documentService = useDocumentService();

  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });

  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useQuery({
    queryKey: ["documentDeliveryFilterDimensions", { cardCodes }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "/Delivery/GetDocumentFilterDimensions",
      });
      return documentService
        .getDocumentDeliveriesFilterDimensions(cardCodes)
        .then((data) => mapApiDocumentFilterDimensions(data))
        .catch((err) => {
          trackQueryError(
            {
              statusCode: err.statusCode as number,
              message: err.message,
            },
            eventId
          );
          throw err;
        });
    },
  });
};

export default useGetDocumentDeliveryFilterDimensions;
